import Head from "next/head";
import EmailSignupBanner from "../../../components/EmailSignupBanner";
import Layout from "../../../components/Layout";
import { Divider, Space, Text, Title} from '@mantine/core'
import { MenuId } from "../../../components/Header";
import styles from './public-vote.module.scss'


import { GetServerSideProps } from "next";



import imgCass from './images/cass_art_logo_1984_black-01.jpg';

import Link from "next/link";
import Image from 'next/image';

import imgAandI from './images/a-and-i.png';
import imgCBPP from './images/cbpp.jpg';
import imgMallGalleries from './images/mall-galleries.png';
import imgRP from './images/the-rp-high-res.jpg';
import { logEvent } from "../../../lib/logger";
import { AspectBox } from "../../../components/AspectBox";
import { JWHostedPlayer, JWHostedPlayer2 } from "../../../components/Video";


export default function Results(props : {competitionStatus?:string})
{
 
    return(
        <>
      
        <Layout menuId={MenuId.online} hideBanner={true}>

  
  <Head>
      <title>Paint Off 2026</title>
      <meta name="description" content="Find out what happened at the the Raw Umber Studios Paint Off"/>    
      <Head>
            <title>Raw Umber Studios Portrait Paint Off 2026</title>
            <meta name='description' content="Find out what happened at the the Raw Umber Studios Paint Off"/>
            <meta property='og:image' content='https://rawumberstudios.com/n/paint-off-2026-2599x1087.png'/>
            <meta property='og:image-width' content='1200'/>
            <meta property='og:image-height' content='630'/>
        </Head>  
  </Head>
  <div className = {styles.mainContent}>
                 
    <div style={{display:'flex', justifyContent:'center'}}>
  <div  style={{width:'100%', maxWidth:'700px', aspectRatio:'16/9', marginTop:10}}>                 
  <JWHostedPlayer2 jwId='ROP1zCEI' loop={true} autostart={true} controls={true} mute={true}/>
  </div>
    </div>

  <h1 className={styles.h1}>Portrait Paint Off 2026</h1>
    <Text>In June 2026, seven top portrait artists joined us at our studios in Stroud and spent a day painting from life. We filmed them painting, interviewed them, and talked to the judges. The result is a fascinating 90 minute documentary, full of insights about their processes and painting in general.</Text>

    <Text mt='md'>Want to find out happened? <Link href='https://youtu.be/PGTHaq6BlXM' onClick={()=>{logEvent('po2026-yt', {})}}>watch the first episode on YouTube</Link> for FREE</Text>
      <Text mt='md'>
        To watch the second episode, <Link href='/subscription' onClick={()=>{logEvent('po-results-26', {action:'subscribe'})}}>subscribe</Link> (you&rsquo;ll need a Gold subscription) and <Link href='/videos/paint-off-2026' onClick={()=>{logEvent('po-results-26', {action:'full'})}}>watch it here</Link>
        </Text>
    <Text mt='md'>Don&rsquo;t have the time and just want to find out who the winner was? Go <Link onClick={()=>{logEvent('po-results-26', {action:'winner'})}} href='/paint-off-2026-winner'>here</Link></Text>
    
    {props.competitionStatus=="ALL-DONE" && <Text mt='md'>As well as a prize worth £2,500 awarded by our judges (Lizet Dingemans, Luca Indraccolo and Andrew James), we awarded a second prize of £500 cash and £250 of Cass Art vouchers, chosen by you the public. To see the winner, go <Link  onClick={()=>{logEvent('po-results-26', {action:'mod'})}} href='/the-winner-of-the-public-vote-for-raw-umber-studios-paint-off-2026'>here</Link>. You can see all the artists&rsquo; work <Link onClick={()=>{logEvent('po-results-26', {action:'finalists'})}} href='public-vote'>here</Link></Text>}
    {props.competitionStatus=="PUBLIC-VOTING" && <Text mt='md'>As well as a prize worth £2,500 awarded by our judges (Lizet Dingemans, Luca Indraccolo and Andrew James), we will award a second prize of £500 cash prize and £250 of Cass Art vouchers, chosen by you the public. To vote, go <Link  onClick={()=>{logEvent('po-results-26', {action:'vote'})}} href='public-vote'>here</Link>. You can see all the artists&rsquo; work <Link onClick={()=>{logEvent('po-results-26', {action:'finalists'})}} href='public-vote'>here</Link></Text>}
    {props.competitionStatus=="VOTING-CLOSED" && <Text mt='md'>As well as a prize worth £2,500 awarded by our judges (Lizet Dingemans, Luca Indraccolo and Andrew James), we will award a second prize of £500 cash prize and £250 of Cass Art vouchers, chosen by you the public. Voting is closed, and we will soon announce the winner. In the meantime, you can see all the artists&rsquo; work <Link onClick={()=>{logEvent('po-results-26', {action:'finalists'})}} href='public-vote'>here</Link></Text>}

      </div>

  
  <Space h='lg'/>
  

<div>
<Divider my="sm" variant="dotted" />
<Title order={3} mb='sm' ta="center">We&rsquo;d like to thank our supporters. In alphabetical order, they are:</Title>

<div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
    <div className={styles.logo}><a href='https://www.artistsandillustrators.co.uk/' target='_blank'><Image src={imgAandI} width={250} alt='Artists & Illustrators Logo'/></a></div>
    <div className={styles.logo}><a href='https://cassart.co.uk' target='_blank'><Image src={imgCass} width={250} alt='Cass Art'/></a></div>
    <div className={styles.logo}><a href='https://www.thecbpp.org' target='_blank'><Image src={imgCBPP} width={250} alt='CBPP Logo'/></a></div>
    <div className={styles.logo}><a href='https://therp.co.uk/' target='_blank'><Image src={imgRP} width={250} alt='The RP Logo'/></a></div>
</div>
</div>

  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

  export const getServerSideProps : GetServerSideProps = async (context)=>
  {
    let competitionStatus = process.env.PAINT_OFF_2026_STATUS;
  
      /* possible statuses(those with * will be redirected):
      404 - Hidden *
      ENTRIES-OPEN
      ENTRIES-CLOSED
      EVENT-HAPPENED
      PUBLIC-VOTING *
      VOTING-CLOSED *
      ALL-DONE *
      */
  
      if (competitionStatus!="PUBLIC-VOTING" && competitionStatus!="VOTING-CLOSED" && competitionStatus!="ALL-DONE")
      {
          return {notFound:true}
      }
        
  
      return {
        props: {
          competitionStatus: competitionStatus
        }
  
      }
  }
  
